import { render, staticRenderFns } from "./TokensManager.vue?vue&type=template&id=7e47f74e"
import script from "./TokensManager.vue?vue&type=script&lang=js"
export * from "./TokensManager.vue?vue&type=script&lang=js"
import style0 from "./TokensManager.vue?vue&type=style&index=0&id=7e47f74e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports